import type { SarCategoryKey } from './SarInterfaces';

class SarTagCategoryMapper {
    public static mapTagToCategory(tag: string): SarCategoryKey | null {
        const lowerTag = tag.toLowerCase();

        switch (lowerTag) {
            // Yükümlü
            case 'yukumlu':
                return 'yukumlu';

            // Temel Bilgiler
            case 'bildirimkategorisi':
            case 'yerelreferansno':
            case 'oncekibildirimreferansno':
            case 'aciliyet':
            case 'terororgutu':
                return 'temelbilgiler';

            // Gerçek Kişiler 
            // NOT: tckn, vkn, ykn, magdur gibi ortak alanlar burada belirtilmiyor
            // Bu alanlar field ID prefix kontrolü ile belirleniyor (gercekkisi-, digerkisi-, hesap-)
            case 'adi':
            case 'soyadi':
            case 'dogumtarihi':
            case 'dogumyeri':
            case 'anaadi':
            case 'babaadi':
            case 'uyrugu':
            case 'cinsiyeti':
            case 'meslek':
            case 'ekbilgi':
            case 'kimlikbilgilerisahte':
            case 'kimliktespitturu':
            case 'islemlebaglantisi':
            case 'islemlebaglantisiaciklama':
            case 'belgeturu':
            case 'belgenumarasi':
            case 'gecerliliktarihi':
            case 'adressatir':
            case 'postakodu':
            case 'ilkodu':
            case 'ilcekodu':
            case 'ulkekodu':
            case 'iletisimbilgisi':
            case 'iletisimbilgileri':
                // tckn, vkn, ykn, magdur - ortak alanlar, field ID prefix kontrolü ile belirleniyor
                return 'gercekkisiler';

            // Diğer Kişiler 
            // NOT: vkn, magdur gibi ortak alanlar burada belirtilmiyor
            // Bu alanlar field ID prefix kontrolü ile belirleniyor (digerkisi-)
            case 'kurulusnevi':
            case 'unvan':
            case 'isletmeadi':
            case 'sicilno':
            case 'faaliyetkonusu':
            case 'kurulustarihi':
            case 'websitesi':
            case 'ekbilgi':
            case 'kimlikbilgilerisahte':
            case 'islemlebaglantisi':
            case 'islemlebaglantisiaciklama':
            case 'ulkekodu':
            case 'ilkodu':
            case 'ilcekodu':
            case 'adressatir':
            case 'postakodu':
            case 'iletisimbilgisi':
            case 'iletisimbilgileri':
                // vkn, magdur - ortak alanlar, field ID prefix kontrolü ile belirleniyor
                return 'digerkisiler';

            // Şüpheli İşlemler
            // NOT: parabirimi ortak alan, hem şüpheli işlemler hem hesaplar kategorisinde kullanılıyor
            // Bu yüzden field ID prefix kontrolü ile belirlenmeli
            case 'islemcesidi':
            case 'islemtarihi1':
            case 'islemtarihi2':
            case 'islemdurumu':
            case 'hesababagli':
            case 'tutartp':
            case 'tutar':
            case 'islemturu':
            case 'islemkanali':
            case 'ipv4':
            case 'port':
            case 'islemaciklamasi':
            case 'islemingerceklestirildigiyer':
            case 'islemintetiklendigiyer':
            case 'islemearaciliketmedurumu':
            case 'islemearacilikedenkurum':
            case 'iletisimbilgileri':
            case 'iletisimbilgisi':
                // parabirimi - ortak alan, field ID prefix kontrolü ile belirleniyor
                return 'supheliislemler';

            // Hesaplar
            // NOT: tckn, vkn, ykn, magdur, adsoyadunvan, pasaport, parabirimi gibi ortak alanlar burada belirtilmiyor
            // Bu alanlar field ID prefix kontrolü ile belirleniyor (hesap- veya hesap-hesapsahibi-)
            case 'sahisfirmasihesabi':
            case 'hesapturu':
            case 'hesapno':
            case 'iban':
            case 'acilistarihi':
            case 'kapanistarihi':
            case 'sonislemtarihi':
            case 'bakiyetp':
            case 'bakiye':
            case 'kisitlamaturu':
            case 'kisitlamadigeraciklama':
                // tckn, vkn, ykn, magdur, adsoyadunvan, pasaport, parabirimi - ortak alanlar, field ID prefix kontrolü ile belirleniyor
                return 'hesaplar';

            // Şüphe Kategorileri
            case 'suphekategorisi':
                return 'suphekategorileri';

            // Bildirim Açıklama
            case 'bildirimaciklama':
                return 'bildirimaciklama';

            default:
                return null;
        }
    }
}

export default SarTagCategoryMapper;

